import Env from 'Services/Env';

const tilesPatternUrl = 'https://tile.jawg.io/jawg-sunny/{z}/{x}/{y}.png';
class MapService {
    constructor() {
    }

    getLang() {
        if (window.App.lang === 'ca') {
            // catalan is not supported by jawg, fallback to spanish
            return 'es';
        }
        if (!['en', 'fr', 'it', 'es', 'de', 'nl', 'zh'].includes(window.App.lang)) {
            // fallback to french if not supported by jawg
            // https://www.jawg.io/docs/integration/leaflet/change-language/
            return 'fr';
        }
        return window.App.lang;
    }

    getTileLayer(token, lang) {
        return tilesPatternUrl + '?access-token=' + (token ?? Env.get('jawg').token) + '&lang=' + (lang ?? this.getLang());
    }
}

const mapService = new MapService()
export default mapService;
